import { Component, Output, EventEmitter } from '@angular/core';

import { LucideAngularModule, MessageSquare, ArrowLeft } from 'lucide-angular';

/**
 * Bot Not Found Component - Shared error state
 */
@Component({
  selector: 'app-bot-not-found',
  standalone: true,
  imports: [LucideAngularModule],
  template: `
    <div class="flex-1 flex items-center justify-center mt-20">
      <div class="text-center max-w-md">
        <div class="w-20 h-20 bg-light-bg-secondary dark:bg-dark-surface-variant rounded-3xl flex items-center justify-center mx-auto mb-6">
          <lucide-angular [img]="MessageSquare" class="w-10 h-10 text-light-text-tertiary dark:text-dark-text-tertiary"></lucide-angular>
        </div>
        <h2 class="mb-4">
          Bot no encontrado
        </h2>
        <p class="normal mb-8">
          El chatbot solicitado no se encontró. Por favor, elige un chatbot diferente.
        </p>
        <button
          (click)="onBack.emit()"
          class="flex items-center gap-2 mx-auto px-6 py-3 bg-light-primary text-white rounded-2xl hover:bg-light-primary-variant dark:bg-dark-primary dark:hover:bg-dark-primary-variant transition-colors shadow-soft"
        >
          <lucide-angular [img]="ArrowLeft" class="w-4 h-4"></lucide-angular>
          <span class="font-medium">Regresar a Chatbots</span>
        </button>
      </div>
    </div>
  `,
})
export class BotNotFoundComponent {
  @Output() onBack = new EventEmitter<void>();
  
  readonly MessageSquare = MessageSquare;
  readonly ArrowLeft = ArrowLeft;
}
